export const FETCH_DSR_LOGS_DOWNTIME = '@@material/dsr-log-downtimes';
export const FETCH_DSR_LOGS_DOWNTIME_SUCCESS = '@@material/dsr-log-downtimes-success';
export const FETCH_DSR_LOGS_DOWNTIME_FAILURE = '@@material/dsr-log-downtimes-failure';
